import { ApolloProvider } from "@apollo/client/react";
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useApolloSettings } from "../contexts/global/ApolloSettingsContext";

import apolloClient from "./apolloClient";

const TenantApolloProvider = ({ children }) => {
  const {
    getTokenSilently,
    overrideTenant,
    workspaceId,
    dateSettings,
    apiUrl,
  } = useApolloSettings();

  // Only recreate client when the values apolloClient actually uses change.
  // Specifically solves client being unstable due to location (path) changes on search page.
  const client = useMemo(
    () =>
      apolloClient({
        getTokenSilently,
        overrideTenant,
        workspaceId,
        dateSettings,
        apiUrl,
      }),
    [getTokenSilently, overrideTenant, workspaceId, dateSettings, apiUrl]
  );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

TenantApolloProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TenantApolloProvider;
